import type { CardDefinition } from './card-definition'

export function validateCatalog(...catalog: CardDefinition[]): CardDefinition[] {
  // Keep track of card names to ensure uniqueness
  const cardNames = new Set<string>()

  // Validate each card definition
  for (const card of catalog) {
    // Check card name uniqueness
    if (cardNames.has(card.cardName)) {
      throw new Error(`Duplicate card name: ${card.cardName}`)
    }
    cardNames.add(card.cardName)

    // Track field names for uniqueness within a card
    const fieldNames = new Set<string>()

    // Validate each field for name uniqueness within this card
    for (const field of card.fields) {
      // Check field name uniqueness within the card
      if (fieldNames.has(field.name)) {
        throw new Error(`Duplicate field name: ${field.name} in card ${card.cardName}`)
      }
      fieldNames.add(field.name)
    }
  }

  return catalog
}
